<template>
    <div class="info">
        <div class="option" v-for="(item,i) in infoList" :key="i">
            <div class="left">
                <img :src="require(`../../../../assets/images/epidemicForm/icon${ i+2 }.png`)" alt=""/>
            </div>
            <div class="right">
                <span class="up">
                    <i class="num">{{ item.num }}</i>
                    <i class="unit">人</i>
                </span>
                <span class="down">{{ item.word }}</span>
            </div>
        </div>
    </div>    
</template>
<script>
import miment from 'miment';
export default {
    data(){
        return {
            infoList: [
                {
                    num: 0,
                    prop: 'allCount',
                    word: '今日提交'
                },
                {
                    num: 0,
                    prop: 'noFever',
                    word: '健康'
                },
                {
                    num: 0,
                    prop: 'fever',
                    word: '发热'
                },
            ]
        }
    },
    props: {
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            let res = await this.$get(
                this.urlobj.getEpidemicHealthStatistics,{
                    communityId: this.$route.query.communityId || this.$store.state.streetorcommunityid,
                    beginTime: starttime,
                    endTime: endtime
                }
            )
            this.infoList.forEach(item => {
                item.num = Number(res.rows[0][item.prop])
            })
        }
    },
    watch: {
        date(newVal){
            let starttime,endtime

            

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }

            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            }
            this.getInfo(starttime,endtime)
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>
.info {
    box-sizing: border-box;
    padding: 25px 20px;
    color: #fff;
    display: flex;
    align-items: center;
    .option{
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px 0 14px;
        border-right: 1px solid #2f3448;
        .left{
            width: 68px;
            height: 68px;
            border-radius: 50%;
            background: #3d5bd3;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
        }
        .right {
            height: 55px;
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            .up {
                color: #1673ec;
                font-size: 16px;
                .num {
                    font-size: 24px;
                    font-weight: 800;
                }
            }
            .down {
                font-size: 13px;
                color: #959ab0;
            }
        }
    }
    .option:first-of-type{
        padding: 0 8px 0 0;
    }
    .option:last-of-type{
        padding: 0 0 0 14px;
        border-right: none;
    }
}
</style>